import React from 'react';
import styled from 'styled-components';
import { Text18Medium, Text48Medium, Text24Medium } from '../../mixins/mixins';

const AboutUsComponent = styled.div`
  display: flex;
  flex-direction: column;
  background: rgba(1, 31, 61, 1);
  padding: 96px 24px 104px;
  @media (max-width: 669px) {
    padding: 63px 12px 63px;
  }
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.div`
  ${Text48Medium};
  margin-bottom: 32px;
  @media (max-width: 669px) {
    ${Text24Medium};
  }
`;

const ValuesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 64px;
  @media (max-width: 669px) {
    margin-top: 32px;
  }
`;

const ValuesHeader = styled.div`
  ${Text24Medium};
  margin-bottom: 24px;
  @media (max-width: 669px) {
    margin-bottom: 24px;
  }
`;

const ValuesList = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: 25px;
  @media (max-width: 669px) {
    grid-template-columns: 1fr;
    grid-row-gap: 22px;
    margin-top: 4px;
  }
`;

const ItemValue = styled.div`
  ${Text18Medium};
  color: rgba(255, 255, 255, 0.6);
`;

const Description = styled.div`
  ${Text18Medium};
  width: 100%;
  @media (max-width: 669px) {
    margin-bottom: 24px;
  }
`;

const Subtitle = styled.div`
  ${Text18Medium};
  width: 388px;
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 32px;
  @media (max-width: 669px) {
    width: unset;
  }
`;

const AboutUs: React.FC = () => (
    <AboutUsComponent>
        <TitleWrapper>
            <Title>About us</Title>
            <Subtitle>
                Company with eight years of experience in the supply of goods from
                Chinese and Asian manufacturers to foreign customers.
            </Subtitle>
            <Description>
                During this time, we have established strong relationships with
                manufacturers of electronics and consumer goods. Our logistics partners
                ensure reliability during the transportation of goods.
            </Description>
        </TitleWrapper>
        <ValuesWrapper>
            <ValuesHeader>Our principles</ValuesHeader>
            <ValuesList>
                <ItemValue>
                    Our partnerships with Chinese manufacturers allow us to offer you
                    special purchase conditions.
                </ItemValue>
                <ItemValue>
                    We control the production and shipment of goods to ensure their quality
                    and conformity with the declared ones.
                </ItemValue>
                <ItemValue>
                    We care about the reputation of our company, so we are responsible for
                    our mistakes.
                </ItemValue>
            </ValuesList>
        </ValuesWrapper>
    </AboutUsComponent>
);

export default AboutUs; 